query GetContentGenerationApiInfo {
    contentGenerationApiInfo {
        url
    }
}
